import Image from 'next/legacy/image'
import * as React from 'react'

type TImageProps = Omit<PropsOf<typeof Image>, 'loader' | 'unoptimized'>

type TProps = NoChildren & TImageProps

type TNextImageLoader = PropsOf<typeof Image>['loader']

const customLoader: TNextImageLoader = ({ src }) => src

/**
 * Wrapped `next/legacy/image` component with the custom loader.
 * Our images are provided as an imageUrl's to cdn
 * and therefore we don't want the next to handle the URL.
 *
 * https://nextjs.org/docs/api-reference/next/image#loader
 * https://nextjs.org/docs/api-reference/next/image#unoptimized
 */
export const NextImage: React.FC<TProps> = (imageProps) => {
  return <Image {...imageProps} loader={customLoader} unoptimized />
}
